import React from 'react'
import { Link } from 'gatsby'
import { connectStateResults } from 'react-instantsearch-dom'
import { useSelector, useDispatch } from 'react-redux'

import trads from '~/intl/trads.json'

import CustomHitsLabo from '~/components/features/labo/hitsLabo'
import LinkIcon from '~/components/core/linkIcon'
import LaboCard from '~/components/features/cards/laboCard'

import { setHasLaboOpen } from '~/store/actions'
import scrollManager from '~/utils/scrollManager'

const StateResults = ({ searchResults, searchState }) => {
  const dispatch = useDispatch()
  const lang = useSelector((state) => state.lang)
  const query = useSelector((state) => state.currentSearchQuery)
  let emptyLabo = useSelector((state) => state.laboEmptyLabo)
  const hitsLength =
    searchResults !== null
      ? searchResults.hits.filter((hit) => hit.contentType === 'labo').length
      : 0

  return (
    <>
      {/* only display something if query has 3 or more characters */}
      {searchState.query !== undefined && searchState.query.length >= 3 && (
        <>
          {hitsLength > 0 ? (
            <>
              {/* case with results */}
              <div className="sm:flex justify-between mb-4">
                <p className="title-block title-block--no-margin pr-4 pb-2 sm:pb-0">
                  {trads[lang].lab.titleContentTypes.labo}
                </p>
                {hitsLength > 3 && (
                  <Link
                    onClick={() => {
                      dispatch(setHasLaboOpen(false))
                      scrollManager.restart()
                    }}
                    to={
                      lang === 'fr'
                        ? `/labo?q=${encodeURI(query)}`
                        : `/en/lab?q=${encodeURI(query)}`
                    }
                    state={{ filters: ['labo'], searchQuery: query }}
                  >
                    <LinkIcon
                      text={`<span class="hidden md:block text-medium-green-2">${trads[lang].lab.linkContentTypes.labo}</span>
                  <span class="md:hidden text-medium-green-2" aria-hidden="true">${trads[lang].lab.seeAllMobile}</span> <sup class='labo__results-number text-medium-green-2'>(${hitsLength})</sup>`}
                    />
                  </Link>
                )}
              </div>
              <CustomHitsLabo />
            </>
          ) : (
            <>
              {/* case no results */}
              <p className="title-block title-block--no-margin text-center -mt-3">
                {trads[lang].lab.laboNoResults}
              </p>
              <p className="text-white text-center mt-3 font-semibold">
                {trads[lang].lab.laboNoResults2}
              </p>

              <ul className="lg:w-full full-width-tablet flex overflow-auto lg:overflow-visible mt-6 mb-12 md:mb-0">
                {emptyLabo.map((item, i) => {
                  return (
                    <li key={i} className="labo__labo-card">
                      <LaboCard labo={item} />
                    </li>
                  )
                })}
              </ul>
            </>
          )}
        </>
      )}
    </>
  )
}

const ResultsLabo = connectStateResults(StateResults)

export default ResultsLabo
